import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from "react";
/**
 * This hook will help you determine if a child element exists inside a JSX.element.
 * It does this by checking if the JSX.element has a `displayName`.
 * The displayName is the fn name of the component.
 *
 * Important! You need to manually name slotted components, so their display names aren't minified, see HamburgerMenu
 */
export default function useSlot({ element = _jsx(_Fragment, {}), displayName }) {
    const searchSlot = useCallback((element, name) => {
        var _a;
        if (!displayName)
            return;
        if (checkSlot(element, name))
            return element;
        const children = (_a = element === null || element === void 0 ? void 0 : element.props) === null || _a === void 0 ? void 0 : _a.children;
        if (typeof children === "string")
            return;
        if (!children || !children.length)
            return;
        return children.find((child) => {
            if (child && checkSlot(child, name))
                return true;
            return !!searchSlot(child, name);
        });
    }, []);
    const checkSlot = useCallback((element, name) => { var _a; return ((_a = element === null || element === void 0 ? void 0 : element.type) === null || _a === void 0 ? void 0 : _a.displayName) === name; }, []);
    return useMemo(() => searchSlot(element, displayName), [element, displayName]);
}
